import { useContext } from "react"

// Navigation
import { Routes } from "@/constants/routes"
import { useLocation } from "@/lib/router"

// Context
import { AuthLayoutContext } from "@/layouts/AuthLayout"

// UI
import { cn } from "@/lib/utils"
import { Link } from "@/components/Anchor"
import { NavItem } from "@/components/navigation/NavItem"

// Icons
import { UsersIcon } from "@/lib/icons"

// Translation
import { useTrans } from "@/i18n"

export function CommunitySubMenu() {
	const location = useLocation()
	const t = useTrans(["common", "investor"])
	const { setMobileMenuOpen } = useContext(AuthLayoutContext)

	function closeMenu() {
		setMobileMenuOpen(false)
	}

	return (
		<NavItem
			name={t("common:nav.community")}
			data-testid="common:nav.community"
			icon={UsersIcon}
		>
			<nav className="space-y-1 pr-3">
				<Link
					className={cn(
						location.pathname === Routes.CommunityShare &&
							"active-navigation-item",
						"block truncate text-sm hover:text-gray-500",
					)}
					href={Routes.CommunityShare}
					onClick={closeMenu}
				>
					{t("investor:community.invites.title")}
				</Link>
			</nav>
		</NavItem>
	)
}
